import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { ImageComponent } from './image.component';
import { SharedModule } from '../shared/shared.module';

const setupRoutes: Routes = [
    {
    path: 'image',
    component: ImageComponent
    }
];

@NgModule({
  declarations: [
    ImageComponent, 
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forChild(setupRoutes)
  ],
  bootstrap: [
    ImageComponent
  ],
  exports: [
    ImageComponent  
  ]
})

export class ImageModule {}